<script setup lang="ts">
import { watchEffect } from "vue";
import { useRouter } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import { useLandingRoute } from "@/composables/shared/useLandingRoute";
import Loading from "@/components/shared/Loading.vue";
import { useAuthStore } from "@/stores/authStore";

definePage({
  meta: {
    title: "generic.entity.dashboard",
    checkPrivileges: () => true,
  },
});

const router = useRouter();
const authStore = useAuthStore();
const { landingRoute } = useLandingRoute();

watchEffect(() => {
  if (!authStore.isSessionReady) return;

  router.replace(landingRoute.value);
});
</script>

<template>
  <div class="tw:flex tw:h-full tw:items-center tw:justify-center">
    <Loading
      :size="32"
      class="tw:my-6!"
    />
  </div>
</template>
